import { useEffect, useCallback } from 'react';

export function useScrollAware(
  onScroll: (scrollProps: { scrollTop: number; scrollHeight: number; bodyWidth: number }) => void,
  scrollNode?: HTMLElement
) {
  const calculateProps = useCallback(
    () => ({
      scrollTop: scrollNode ? scrollNode.scrollTop : window.scrollY,
      scrollHeight: (scrollNode || window.document.body).scrollHeight,
      bodyWidth: (scrollNode || window.document.body).clientWidth,
    }),
    [scrollNode]
  );

  useEffect(() => {
    if (window) {
      const handleScroll = () => onScroll(calculateProps());
      if (scrollNode) {
        scrollNode.addEventListener('scroll', handleScroll);
        return () => scrollNode.removeEventListener('scroll', handleScroll);
      } else {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
      }
    }
  }, [calculateProps, onScroll, scrollNode]);
}
